<template>
  <div>
    <list
      row-key="id"
      ref="list"
      unit="学期报表"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.getStat"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" style="padding-right:16px;">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍号">
          <el-input size="mini" v-model="params.Dormitory" placeholder="请填写宿舍号" clearable/>
        </el-form-item>
        <el-form-item label="违纪类别" class="longForm">
          <el-select v-model="params.DisciplineTypeIdChains" multiple filterable clearable>
            <el-option v-for="item in disciplineList" :key="item.DisciplineTypeId" :label="item.DisciplineTypeName" :value="item.IdChain">
              <span v-if="item.Lv==2" class="l-icon">L</span>
              <span>{{item.DisciplineTypeName}}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Grade" label="年级" />
        <el-table-column prop="Class" label="班级" />
        <el-table-column prop="StudentCount" label="人数" />
        <el-table-column prop="Point" label="总扣分值" />
        <el-table-column prop="DisciplineTypeNameChain" label="扣分值最多类型" min-width="110px"/>
        <el-table-column prop="New8FullNames" label="新增达8分学生" min-width="110" />
        <el-table-column prop="After6FullNames" label="处理后新增扣分达6分" min-width="125px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      api: require("@/api/attendance/disrecord").default,
      disApi: require("@/api/attendance/disciplinetype").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      termApi: require("@/api/ed/term").default,
      params: {
        TermId: 0,
        GradeId: null,
        ClassId: null,
        Dormitory: "",
        StartDate: "",
        // EndDate: "",
        DisciplineTypeIdChains: [],
        Stat: true,
        StatType: this.type
      },
      disciplineList: [],
      termList: [],
      grades: [],
      classes: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    this.params.TermId = loginInfo.TermId;
    this.termApi.list().then((res) => {
      if (res.Data && res.Data.length > 0) {
        this.termList = res.Data;
        this.$refs.list.initQueryParams.TermId = this.params.TermId;
      }
    });
    this.disApi.list({ Status: 1 }).then(res => {
      this.disciplineList = res.Data;
    });
    this.getGrade();
  },
  methods: {
    termChange(e) {
      this.params.ClassId = null;
      this.getClass();
      this.getGrade();
      this.query({ TermId: e });
    },
    getGrade() {
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
      });
    },
    getClass() {
      this.params.ClassId = null;
      if (!this.params.GradeId) {
        this.classes = [];
        return;
      }
      var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
      this.class_api.list(params).then((res) => {
        this.classes = res.Data;
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.l-icon {
  margin: 0 2px 0 5px;
  vertical-align: 3px;
}
.longForm {
  width: 554px;
  /deep/ .el-input__inner {
    width: 100% !important;
  }
}
</style>